export const getWikiErrorMessage = (error, fallbackMessage) => {
  if (error?.status === 403) {
    return 'Vous n avez pas les droits necessaires pour effectuer cette action.';
  }

  const technicalMessage = String(error?.message || '').toLowerCase();
  if (
    technicalMessage.includes('failed to fetch')
    || technicalMessage.includes('networkerror')
    || technicalMessage.includes('load failed')
  ) {
    return 'Impossible de charger les donnees du Wiki.';
  }

  return error?.message || fallbackMessage;
};
